import type { FaireProductEntity } from "../../entity_types/product";

export const p_svmckrawta: FaireProductEntity = {
  token: "p_svmckrawta",
  type: "product",
  name: "Congrats Pennant Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/bbe54564e87493d0c1b3945df88b75383dd569be1280be877c99b8383a4124e2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a28cb4eb51fc8875448cfde4958ab30d0949e8c4ad83a6f01cb78ad5b7ca970a.jpeg",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:00.517Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
